export default {
  title: 'Importovať {type}',
};
